export default "__VITE_ASSET__d$8qRrRa__"